<template>
    <div class="float-left pr-1" v-if="this.errors_array.length>0">
      <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

      <b-popover :show.sync="showPopover" target="popoverButton-sync" title="Erros Encontrados" data-html="true" placement="leftbottom">
        <table class="table" id="mais">
          <tbody>
          <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
            <td v-html="item.erro">
              {{ item.erro }}
            </td>
          </tr>
          </tbody>
        </table>
      </b-popover>
    </div>
</template>
<script>
export default {
    props: {
        errors_array: Array,
    },
    data () {
        return {
            showPopover: false,
        }
    },
  }
</script>
